module.exports = __webpack_public_path__ + "agile-technologies.3F5MJw52.svg";